var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('GmapMap',{staticStyle:{"width":"100%","height":"500px"},attrs:{"center":_vm.center,"zoom":15}},[_c('GmapMarker',{attrs:{"position":_vm.center}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }